export default function ({ store, $sentry }) {
  if (!$sentry || !process.client) {
    return
  }

  // Function to set Sentry user context
  const setSentryUser = () => {
    let userData = null

    // Priority 1: Logged in doctor data from store
    if (store.state.doctorData) {
      userData = {
        id: store.state.doctorData.ID,
        email: store.state.doctorData.Email,
        username: store.state.doctorData.PersonalUrl || store.state.doctorData.Fullname
      }
    } else if (store.state.register_doctor?.profile) {
      // Priority 2: Registration profile from store
      const profile = store.state.register_doctor.profile
      userData = {
        id: profile.ID,
        email: profile.Email,
        username: profile.PersonalUrl || profile.Fullname
      }
    } else if (store.state.register_doctor?.email) {
      // Priority 3: Email from register_doctor store
      userData = {
        email: store.state.register_doctor.email
      }
    } else {
      // Priority 4: localStorage fallback
      try {
        const storedData = localStorage.getItem('doctor-data')
        if (storedData) {
          const parsed = JSON.parse(storedData)
          userData = {
            id: parsed.ID,
            email: parsed.Email,
            username: parsed.PersonalUrl || parsed.Fullname
          }
        }
      } catch (e) {
        // Ignore localStorage errors
      }
    }

    if (userData) {
      $sentry.setUser(userData)
    }
  }

  // Set user on initial load
  setSentryUser()

  // Watch for store changes to update Sentry user
  store.watch(
    state => state.doctorData,
    () => setSentryUser()
  )

  store.watch(
    state => state.register_doctor?.profile,
    () => setSentryUser()
  )

  store.watch(
    state => state.register_doctor?.email,
    () => setSentryUser()
  )
}
